export default __webpack_public_path__ + "static/medium-image-applozic-1-f1a579a3027dbb94fb314db84cc8bbfc.png";